<div class="d-flex flex-row">
  <nav [class.wallet]="appProperties.name === 'cargowallet'">
    <h1>{{ tabTitle }}</h1>
    <ul
      class="nav flex-column nav-pills"
      id="v-pills-tab"
      role="tablist"
      aria-orientation="vertical"
    >
      @for (group of items; track group) {
        <li class="nav-group">
          <span>{{ group.groupName }}</span>
          <ul>
            @for (item of group.groupItems; track item) {
              <li class="nav-item">
                <a
                  role="button"
                  (click)="onSelectNavItem.emit(item.key)"
                  [class.active]="item.key === selectedNavItem"
                >
                  <i [style.mask-image]="'url(' + item.iconUrl + ')'"></i>
                  <span>{{ item.label }}</span>
                </a>
                @if (item.key === selectedNavItem && item.subItems?.length) {
                  <ul>
                    @for (subItem of item.subItems; track subItem) {
                      <li class="nav-sub-item">
                        <a
                          role="button"
                          (click)="onSelectNavSubItem.emit(subItem.key)"
                          [class.active]="subItem.key === selectedNavSubItem"
                        >
                          {{ subItem.label }}
                        </a>
                      </li>
                    }
                  </ul>
                }
              </li>
            }
          </ul>
        </li>
      }
    </ul>
  </nav>
  <div class="flex-grow-1">
    <ng-content></ng-content>
  </div>
</div>
